module.exports = __webpack_public_path__ + "static/media/titleDoor.68875d34.png";